const helpData = [
  {
    id: "earoYKxi143",
    articleName: "How do I download a copy of my car or bike policy?",
    articleText: `Once the payment is made, the option to download the policy would be visible on the screen. You will also get a copy of the policy on your registered email address. 

    Alternatively, you can just login to acko.com with your registered mobile number. On your policy card, please click 'View Details'. You will be redirected to the policy details page where you will see a 'Download Policy' button. Click on the button to download the policy document.`,
  },
  {
    id: "ebroYKxi144",
    articleName: "How do I change details in my car or bike policy?",
    articleText: `Please login to acko.com. On your policy card, please click 'View Details'. You will be redirected to the policy details page where you will see an 'Edit Policy' button. Once you click on the button, a new pop-up will open with all the possible changes you can make in the policy. Select the type of change and provide the new details. Click submit. Post submitting, the new policy copy with the updated details will be generated.
      
      For changes such as Policyholder Name, few documents might be required for us to validate the new details. Once the documents are provided by you, our helpdesk would review and approve the documents and the new policy copy with the updated details will be generated.
      
      For changes such as IDV, addition of a new cover, etc., the premium gets re-calculated and you might need to make an additional payment or be eligible for refund or there might be no change at all. Post the payment, if any, the new policy copy with the updated details will be generated.`,
  },
  {
    id: "ecroYKxi145",
    articleName: "How do I create a claim for my car or bike policy?",
    articleText: `Creating a claim is easy. Just login to acko.com with your registered mobile number. On your Policy Card, click on 'Claim Now'. articleTextwer the few articleNamestions that follow and you are done. Our claims expert will get back to you shortly and assist you on the next steps.`,
  },
  {
    id: "edroYKxi146",
    articleName:
      "How do I download the plan document for mobile or appliance protection?",
    articleText: `Once you purchase the plan, you will receive the plan’s link on your registered mobile number and email ID.

    Alternatively, you can login to acko.com with your mobile number used to buy the plan with Amazon. Visit acko.com/repairs to view all your mobile protection plarticleText. Visit acko.com/appliances to view all your appliance protection plarticleText. Click on any of the plarticleText to view the plan document and download it. `,
  },
  {
    id: "eeroYKxi147",
    articleName:
      "How do I raise a rearticleNamest for mobile or appliance repair?",
    articleText: `Login to acko.com and click on Claims. For mobile repair, click on Mobile Repairs. For appliance repair, click on Appliance and TV Repair.  Select the plan and follow the on-screen process to raise a repair rearticleNamest. You can also track the status of your rearticleNamest at the same place. Please refer to the plan document for more details on exclusions.

    For more details on how to raise a repair rearticleNamest for mobile, please click here
    
    For more details on how to raise a repair rearticleNamest for appliance, please click here`,
  },
  {
    id: "efroYKxi148",

    articleName: "How do I download a copy of my Health Insurance Policy?",
    articleText: `Using website:
    
    1) Visit www.acko.com and click on the login
    
    2) Enter your registered mobile number and then enter the OTP verification code
    
    3) Click on the download policy button
    
    Using App:
    
    1) Download the ACKO app
    
    2) Enter your registered mobile number and then enter the OTP verification code
    
    3) You will be able to see the list of all active policies. 
    
    Click on the download policy button for the policy you wish to download`,
  },
  {
    id: "egroYKxi149",
    articleName: "How do I change details in my Health Insurance Policy?",
    articleText: `We understand you may need to make some changes to the policy such as change in spelling, date of birth, relationship etc. Please note that the amount of premium you pay is calculated based on the details provided by you at the time of purchasing the policy. Changing some of the details such as DOB, pincode etc may have an impact on the policy and premium paid. Simply drop a mail to health@acko.com with the details of changes you are looking to make and our team will take it from there.`,
  },
  {
    id: "ehroYKxi150",
    articleName: "How do I buy an Arogya Sanjeevani health insurance policy",
    articleText: `Buying Arogya Sanjeevani, standard health insurance policy with Acko is simple, easy, and convenient. You can buy a policy within minutes by visiting acko.com and following the steps mentioned below:
      
      1) Start with adding your family members to the insurance policy.
      
      2) Just articleTextwer a few simple articleNamestions about yourself and your family members. We have kept these articleNamestions extremely simple.
      
      3) View amazing plarticleText and prices tailor-made for you.`,
  },
  {
    id: "eiroYKxi151",
    articleName:
      "Where do I access the list of cashless hospitals partnered with ACKO?",
    articleText: `We have a pan-India network of 7000+ multi-speciality hospitals. You can find the complete list here. If you are facing any issues, you can contact us at 1800 266 2256 or write to us on health@acko.com. We’ll be happy to help you. 
    Alternatively, you can also access the list from Health Insurance Homepage in Acko App.`,
  },
  {
    id: "ejroYKxi152",
    articleName:
      "How can I raise a Cashless or Pre-authorisation rearticleNamest?",
    articleText: `To avail cashless facility kindly visit one of our Network hospitals in your city. You can view the Acko Network Hospital List here. The process of availing cashless is as below: 
      1) Visit the TPA/ Insurance/ Billing Department of network hospital and inform them you want to avail cashless facility.
      2) Show your "ecard" tab in the app at the TPA desk and inform TPA desk that FHPL is your TPA and Acko is the Insurer. 
      3) The TPA desk official will give you a Cashless RearticleNamest Form which you need to duly fill and provide necessary documents as rearticleNamested by the TPA desk. 
      4) Please ensure that the TPA desk has sent the cashless rearticleNamest form to TPA for processing of cashless rearticleNamest. 
      5) Once the cashless rearticleNamest is received by the TPA, they will process the cashless and respond back to the hospital in 1-2 hours.`,
  },
  {
    id: "elroYKxi154",
    articleName: "How will I know the status of my claim rearticleNamest?",
    articleText: `You will get regular status updates regarding your claim rearticleNamest via SMS and email. Alternatively, you can call our toll-free number 1800 266 2256 to check your claim's status. You can also view the claim status on the Acko app`,
  },
];

export default helpData;
